import api from './api';

export const fetchScorePredictionMatches = async () => {
  const res = await api.get('/api/score-predictions/matches', {
    params: { _ts: Date.now() },
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    },
  });
  return res.data?.items || [];
};

export const submitScorePrediction = async (matchId, homeScore, awayScore) => {
  const res = await api.post(`/api/score-predictions/matches/${matchId}/prediction`, {
    home_score: Number(homeScore),
    away_score: Number(awayScore),
  });
  return res.data;
};

export const fetchAdminScorePredictionMatches = async () => {
  const res = await api.get('/api/admin/score-predictions/matches', {
    params: { _ts: Date.now() },
  });
  return res.data?.items || [];
};

export const seedAdminScorePredictionMatches = async () => {
  const res = await api.post('/api/admin/score-predictions/seed-world-cup');
  return res.data;
};

export const updateAdminScorePredictionMatch = async (matchId, payload) => {
  const res = await api.put(`/api/admin/score-predictions/matches/${matchId}`, payload);
  return res.data?.item || null;
};

export const distributeAdminScorePredictionRewards = async (matchId) => {
  const res = await api.post(`/api/admin/score-predictions/matches/${matchId}/distribute`);
  return res.data;
};
